import { useEffect, useState } from 'react';
import { Card, Carousel, message } from 'antd';
import { ReModal, ReButton } from "@/components/refineElement";
import MediaConfig from "@/config/media";
import { getLangList } from '@/lib/i18n';
import { convertBase64ToPicture } from "@/lib/uploadFunction";
import { hasPermission } from "@/lib/permissionUtil";
import { MediaType } from "./types";
import MediaModal from './MediaModal';

const { getMediaInfo, uploadMedia } = MediaConfig;

function MediaShare() {
  const [mediaArray, setMediaArray] = useState<MediaType[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const homeT: any = getLangList("home");
  const errorT: any = getLangList("error");

  useEffect(() => {
    getMediaInfoFunction();
  }, []);

  function getMediaInfoFunction() {
    getMediaInfo().then((res: any) => {
      const mediaArray = res?.value ?? [];
      setMediaArray(mediaArray);
    });
  };

  function toggleModal() {
    setIsModalVisible(!isModalVisible);
  };

  function clickEdit(e: any) {
    e.stopPropagation();
    toggleModal();
  };

  function uploadMediaFunction(values: any) {
    const {
      mediaType1,
      mediaType2,
      mediaType3,
      mediaType4,
      mediaType5,
      url1,
      url2,
      url3,
      url4,
      url5,
      part1,
      part2,
      part3,
      part4,
      part5,
    } = values;
    const stringFormat = {
      url1: mediaType1 === 'picture' || mediaType1 === 'none' ? '' : url1,
      url2: mediaType2 === 'picture' || mediaType2 === 'none' ? '' : url2,
      url3: mediaType3 === 'picture' || mediaType3 === 'none' ? '' : url3,
      url4: mediaType4 === 'picture' || mediaType4 === 'none' ? '' : url4,
      url5: mediaType5 === 'picture' || mediaType5 === 'none' ? '' : url5,

      isNone1: mediaType1 === 'none' ? 'true' : 'false',
      isNone2: mediaType2 === 'none' ? 'true' : 'false',
      isNone3: mediaType3 === 'none' ? 'true' : 'false',
      isNone4: mediaType4 === 'none' ? 'true' : 'false',
      isNone5: mediaType5 === 'none' ? 'true' : 'false',
    };
    const fileFormat = {
      part1: mediaType1 === 'video' || mediaType1 === 'none' ? '' : part1,
      part2: mediaType2 === 'video' || mediaType2 === 'none' ? '' : part2,
      part3: mediaType3 === 'video' || mediaType3 === 'none' ? '' : part3,
      part4: mediaType4 === 'video' || mediaType4 === 'none' ? '' : part4,
      part5: mediaType5 === 'video' || mediaType5 === 'none' ? '' : part5,
    };
    const params = {
      stringFormat,
      fileFormat,
      isStringTypeToJSON: false,
    };

    uploadMedia(params).then((res: any) => {
      if (!res.success) {
        return message.error(errorT.failed);
      }
      message.success(errorT.success);
      toggleModal();
      getMediaInfoFunction();
    });
  };

  return (
    <>
      <Card
        title={homeT.MEDIA_SHARE}
        size="small"
        extra={hasPermission('HOME_MEDIA_SHARE_EDIT') &&
          <ReButton iconName='edit' onClick={clickEdit} attributeObject={{ size: "small" }} />
        }
      >
        <Carousel className="video-share-container">
          {mediaArray.map((item: MediaType, index: number) => {
            const { url, data } = item;

            return (url || data) ? (
              <div className="video-share-item" key={index}>
                {url
                  ? <iframe width="100%" height="300" src={`https://www.youtube.com/embed/${url}`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
                  : <img className="video-share-item-picture" alt="avatar" src={convertBase64ToPicture(data)} />
                }
              </div>
            ) : null;
          })}
        </Carousel>
      </Card>

      {isModalVisible &&
        <ReModal
          title={homeT.MEDIA}
          onCancel={() => toggleModal()}
          visible={isModalVisible}
          onOk={(data: any) => uploadMediaFunction(data)}
          CollectedForm={MediaModal}
          formProps={{
            info: mediaArray,
          }}
        />
      }
    </>
  );
}

export default MediaShare;